import type {
  ClientLoaderFunctionArgs,
  LinksFunction,
  LoaderFunctionArgs,
  MetaFunction,
} from 'react-router';

import { enhanceWithFilterState } from '@jane/bloom/loaders/clientLoader/filterStateManagement';
import { loadDealsRoute } from '@jane/bloom/loaders/routes/deals.server';
import { dealsRouteMeta } from '@jane/bloom/resources/meta/routes/deals';
import { plpStylesLinks } from '@jane/bloom/resources/plpStylesLinks';
import type { RouteHandle } from '@jane/bloom/types/schemas/bloom/routeHandle';

export const handle: RouteHandle = {
  hydrate: true,
};

export const meta: MetaFunction<typeof loader> = (args) => {
  return dealsRouteMeta(args);
};

export const links: LinksFunction = () => [...plpStylesLinks];

export const clientLoader = async (args: ClientLoaderFunctionArgs) => {
  const serverLoader = await args.serverLoader<typeof loader>();
  const { filterArgs, searchCriteria } = serverLoader;
  return {
    ...serverLoader,
    availableFilters: await enhanceWithFilterState({
      filterArgs,
      searchCriteria,
    }),
  };
};
clientLoader.hydrate = true;

export { productGridShouldRevalidate as shouldRevalidate } from '@jane/bloom/utils/routes/shouldRevalidate';

export const loader = async (args: LoaderFunctionArgs) =>
  loadDealsRoute({ args, shouldPinStore: Boolean(args.params['storeSlug']) });

export { DealsRouteComponent as default } from '@jane/bloom/components/routes/deals/dealsRouteComponent';
